import styled from 'styled-components';
import { rem } from 'polished';
import Calendar from '../../Events/EventsCalendar';

const StyledCalendar = styled(Calendar)`
  max-width: ${rem('360px')};

  .wrapper-calendar {
    margin-top: ${rem('10px')};
    background-color: transparent;
  }

  .title {
    background-color: transparent;
    color: ${props => props.theme.colors.light};
    font-family: ${props => props.theme.fonts.book};
    font-size: ${rem('17px')};
    margin-left: ${rem('23px')};
    padding-left: ${rem('20px')};
    cursor: default;
    line-height: ${rem('20px')};
    display: flex;
    align-items: center;

    & > svg {
      background-color: transparent;
      fill: ${props => props.theme.colors.light};
      width: ${rem('18px')};
      height: ${rem('19px')};
      top: ${rem('4px')};
    }
  }

  .calendar-header {
    background-color: transparent;
    width: ${rem('270px')};
    margin: 0 auto;
  }
  .rbc-calendar {
    height: ${rem('330px')};
  }
  .rbc-month-view {
    border: none;
  }
  .rbc-month-header {
    background-color: rgba(0, 0, 0, 0.5);
  }
  .weekday {
    font-family: ${props => props.theme.fonts.medium};
    color: ${props => props.theme.colors.light} !important;
    font-weight: 500;
  }
  .weekday--weekend {
    color: ${props => props.theme.colors.gray} !important;
  }
  .rbc-date-cell {
    span {
      font-family: ${props => props.theme.fonts.medium};
      font-weight: 500;
    }
  }
  .rbc-day-bg + .rbc-day-bg {
    border-left: ${rem('1px')} solid ${props => props.theme.colors.grayLight};
  }
  .rbc-month-row + .rbc-month-row {
    border-top: ${rem('1px')} solid ${props => props.theme.colors.grayLight};
  }
  .rbc-event-content {
    overflow: visible;
  }
  .rbc-event-content > p {
    margin-top: ${rem('-15px')};
  }
  .rbc-event-content > p:before {
    background-color: ${props => props.theme.colors.primary};
  }
  .rbc-current {
    background-color: ${props => props.theme.colors.graySad};

    &:after {
      background-color: ${props => props.theme.colors.graySad};
    }

    span {
      color: ${props => props.theme.colors.light};
    }
  }
  .event {
    background-color: transparent;
    height: 100%;
  }
  .event-date {
    background-color: ${props => props.theme.colors.dark};
  }
  .event-drag {
    display: none;
  }
  .event-list,
  .event-nothing {
    background-color: rgba(0, 0, 0, 0.7);
    height: ${rem('235px')};
  }
  .event-day {
    font-size: ${rem('12px')};
  }
  .event-today {
    background-color: ${props => props.theme.colors.grayDark};
  }
  .event-nothing {
    margin-top: 0;
    padding-top: ${rem('30px')};
    color: ${props => props.theme.colors.light};
  }
  .event-nothing-icon {
    fill: ${props => props.theme.colors.light};
  }
  .event-hour {
    background-color: rgba(0, 0, 0, 0.9);

    svg {
      fill: ${props => props.theme.colors.light};
    }
  }
  .event-hour-form {
    color: ${props => props.theme.colors.light};
  }
  .event-hour-date {
    color: ${props => props.theme.colors.light};
  }
  .event-hour-title {
    color: ${props => props.theme.colors.light};
  }
`;

export { StyledCalendar };
